import ReactDOM from 'react-dom';
import ContextGlobalProvide from '@providers/ContextGlobalProvider';

import App from './App';
import Cookies from 'js-cookie'

import './index.scss';


document.body.classList.add(Cookies.get('darkMode')==="true"? "darkMode": "lightMode")

ReactDOM.render(
  <ContextGlobalProvide>
      <App />
  </ContextGlobalProvide>,
    document.getElementById('root'),
);
